import type { AnnotationT, FrameStateT } from '../../../../labelling/types';
export function getFramesAfterBulkWrite(frames: FrameStateT[], writes: Array<{
  frameIndex: number;
  annotationId: string;
  annotation: AnnotationT;
}>): FrameStateT[] {
  if (writes.length === 0) return frames;
  const result = [...frames];
  const byFrame = new Map<number, Array<{
    annotationId: string;
    annotation: AnnotationT;
  }>>();
  for (const {
    frameIndex,
    annotationId,
    annotation
  } of writes) {
    let group = byFrame.get(frameIndex);
    if (!group) {
      group = [];
      byFrame.set(frameIndex, group);
    }
    group.push({
      annotationId,
      annotation
    });
  }
  for (const [frameIndex, frameWrites] of byFrame) {
    const frame = result[frameIndex];
    if (!frame) continue;
    const updatedStore = {
      ...frame.annotationStore
    };
    for (const {
      annotationId,
      annotation
    } of frameWrites) {
      updatedStore[annotationId] = annotation;
    }
    result[frameIndex] = {
      ...frame,
      annotationStore: updatedStore
    };
  }
  return result;
}
export function getFramesAfterBulkDelete(frames: FrameStateT[], deletes: Array<{
  frameIndex: number;
  annotationId: string;
}>): FrameStateT[] {
  if (deletes.length === 0) return frames;
  const result = [...frames];
  const byFrame = new Map<number, string[]>();
  for (const {
    frameIndex,
    annotationId
  } of deletes) {
    let group = byFrame.get(frameIndex);
    if (!group) {
      group = [];
      byFrame.set(frameIndex, group);
    }
    group.push(annotationId);
  }
  for (const [frameIndex, ids] of byFrame) {
    const frame = result[frameIndex];
    if (!frame) continue;
    const updatedStore = {
      ...frame.annotationStore
    };
    for (const id of ids) delete updatedStore[id];
    result[frameIndex] = {
      ...frame,
      annotationStore: updatedStore
    };
  }
  return result;
}
export function getFramesAfterWrite(frames: FrameStateT[], frameIndex: number, annotationId: string, annotation: AnnotationT): FrameStateT[] {
  const frame = frames[frameIndex];
  if (!frame) return frames;
  const result = [...frames];
  result[frameIndex] = {
    ...frame,
    annotationStore: {
      ...frame.annotationStore,
      [annotationId]: annotation
    }
  };
  return result;
}
export function getFramesAfterDelete(frames: FrameStateT[], frameIndex: number, annotationId: string): FrameStateT[] {
  const frame = frames[frameIndex];
  if (!frame) return frames;
  const {
    [annotationId]: _removed,
    ...rest
  } = frame.annotationStore;
  const result = [...frames];
  result[frameIndex] = {
    ...frame,
    annotationStore: rest
  };
  return result;
}
export function getFramesAfterPromote(frames: FrameStateT[], frameIndex: number, annotationId: string): FrameStateT[] {
  const frame = frames[frameIndex];
  if (!frame) return frames;
  const currentAnnotation = frame.annotationStore[annotationId];
  if (!currentAnnotation) return frames;
  const result = [...frames];
  result[frameIndex] = {
    ...frame,
    annotationStore: {
      ...frame.annotationStore,
      [annotationId]: {
        ...currentAnnotation,
        keyFrame: {
          ...(currentAnnotation.keyFrame ?? {}),
          isKeyFrame: true,
          type: 'MANUAL'
        }
      }
    }
  };
  return result;
}